// extracted by mini-css-extract-plugin
module.exports = {"digitGroup":"MOTP_digitGroup__3M4RF","success":"MOTP_success__1RAlK","error":"MOTP_error__3F7r6"};